import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { SearchComponent } from './components/search/search.component';
import { SearchResultComponent } from './components/search-result/search-result.component';
import { SharedModule } from '../../components/shared/shared.module';


@NgModule({
    declarations: [
        SearchComponent,
        SearchResultComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        BrowserAnimationsModule
    ],
    exports: [
        SearchComponent
    ]
})
export class SearchModule { }
